import React from 'react'
import styled from "styled-components";
import {Col, Layout, Row, Space, Typography, Image, Button} from "antd";

import {NavLink} from "react-router-dom";
import {GRAY_2, GREE_1} from "../utils/colors";
import Logo from "../assets/imgs/logo.png";
import {
    TwitterOutlined,
    YoutubeFilled,
    InstagramFilled,
    PhoneFilled,
    MailFilled,
    WhatsAppOutlined,
    ShopFilled
} from '@ant-design/icons'
import ContanctIcon from "./ContanctIcon";
import ContentContainer from "./ContentContainer";
import { NAV_ITEMS } from "../settings";
import { useSiteSettings } from "../contexts/SiteSettingsContext";
import Section from "./Section";
import ImageBackground from "./ImageBackground";
import ImageLocationBG from "../assets/imgs/location_bg.jpg";
import BannerWhite from "../assets/imgs/bg_2.jpg";
import QRCodeImage from "../assets/imgs/qr_code_px.png";
import MainTitle from "./MainTitle";
import Text from "./Text";
import Title from "./Title";

const {Footer: AntFooter} = Layout;
const {Paragraph} = Typography


const MapLocation = styled.iframe`
    width: 100%;
    height: 100%;
    min-height: 300px;
`

const StyledAntFooter = styled(AntFooter)`
    min-height: 250px;
    padding: 60px 34px;
    background: ${GRAY_2};
    position: relative;
`
const ImageLogo = styled.img`
    //margin-top: 15px;
    width: 100%;
    height: 80px;
    object-fit: contain;
    max-width: min-content;
`


const Resume = styled(Paragraph)`
    color: black;
    font-size: 16px;
    //font-weight: bold;
`
const LinksContainer = styled(Space)`
    & a {
        color: ${GREE_1};
        font-weight: bold;
        font-size: 16px;

    }

    & a:before {
        content: '-';
        padding-right: 8px;

    }
`
const Link = styled.a`
    font-size: 16px;
    font-weight: bold;
    Color: white;
`

const SocialContainer = styled.div`
    border: 2px solid ${GREE_1};
    //border-radius: 4px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    //padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
        color: ${GREE_1};
        height: 24px;
        width: 24px;
    }

    &:hover {
        background: ${GREE_1};

        svg {
            color: ${GRAY_2};
        }
    }
`

const CopyContainer = styled.div`
    width: 100%;
    color: white;
    background: ${GREE_1};
    padding: 16px;
    text-align: center;
    margin: 0 auto;
`

const NavItem = styled(NavLink)`
  color: black;
  font-size: 14px;
  padding: 10px 0;


`

export default function PublicFooter() {
    const { settings } = useSiteSettings();

    return (
        <>
            <StyledAntFooter>
                <ContentContainer>
                    <ContentContainer>
                        <Row gutter={[8, 8]}>
                            <Col xs={24}>

                                <Row style={{marginTop: 16}} gutter={[16, 16]}>
                                    <Col xs={24} md={8}>
                                        <ImageLogo src={Logo}/>
                                        <Text style={{marginTop: 32}}
                                              color={"#9F9F9F"}>Contatos e
                                            redes sociais</Text>
                                        <Space>
                                            {settings.instagram_url && (
                                                <NavLink to={settings.instagram_url}
                                                         target={'_blank'}>
                                                    <SocialContainer>
                                                        <InstagramFilled/>
                                                    </SocialContainer>
                                                </NavLink>
                                            )}

                                            {settings.whatsapp && (
                                                <NavLink
                                                    target={'_blank'}
                                                    to={`https://wa.me/${settings.whatsapp.replace(/\D/g, '')}`}>
                                                    <SocialContainer>
                                                        <WhatsAppOutlined/>
                                                    </SocialContainer>
                                                </NavLink>
                                            )}

                                            {settings.youtube_url && (
                                                <NavLink to={settings.youtube_url}
                                                         target={'_blank'}>
                                                    <SocialContainer>
                                                        <YoutubeFilled/>
                                                    </SocialContainer>
                                                </NavLink>
                                            )}

                                            {settings.twitter_url && (
                                                <NavLink to={settings.twitter_url}
                                                         target={'_blank'}>
                                                    <SocialContainer>
                                                        <TwitterOutlined/>
                                                    </SocialContainer>
                                                </NavLink>
                                            )}
                                        </Space>


                                    </Col>
                                    <Col xs={24} md={8}>

                                        <Title level={5}>Links úteis</Title>
                                        <Space gap={4} direction={'vertical'}>
                                            {NAV_ITEMS.map(({
                                                                label,
                                                                ...options
                                                            }) =>
                                                (
                                                    <NavItem {...options}>{label}</NavItem>)
                                            )}
                                        </Space>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Title level={5}>Informações para
                                            contato</Title>
                                        <Resume
                                            style={{marginBottom: 0}}> Somos um
                                            Centro de Pesquisas e Estudos da
                                            Cannabis que tem como objetivos
                                            principais a construção de uma
                                            sociedade solidária, com redução
                                            das desigualdades sociais e o
                                            fortalecimento da agricultura
                                            familiar.</Resume>
                                        <Row gutter={[8, 24]}
                                             style={{marginTop: 16}}>
                                            {settings.phone && (
                                                <Col xs={24}>
                                                    <ContanctIcon
                                                        text={settings.phone}
                                                        title={'Telefone'}
                                                        icon={<PhoneFilled/>}/>
                                                </Col>
                                            )}
                                            {settings.email && (
                                                <Col xs={24}>
                                                    <ContanctIcon
                                                        text={settings.email}
                                                        title={'Email'}
                                                        icon={<MailFilled/>}/>
                                                </Col>
                                            )}
                                            {settings.address && (
                                                <Col xs={24}>
                                                    <ContanctIcon
                                                        text={settings.address}
                                                        title={'Endereço'}
                                                        icon={<ShopFilled/>}/>
                                                </Col>
                                            )}
                                        </Row>

                                    </Col>


                                </Row>
                            </Col>


                        </Row>
                    </ContentContainer>
                </ContentContainer>

            </StyledAntFooter>
            <CopyContainer>
                © Todos os direitos reservados - Desenvolvido por <Link
                href={'https://www.codtechdevelopers.com.br'}
                target={'_blank'}> Codtech Developers</Link>
            </CopyContainer>
        </>
    )
}
